module.exports = __webpack_public_path__ + "@/assets/img/koku-turuncu.f16e7d6f.jpeg";